var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.launchContent.layout,{directives:[{name:"easyadmin",rawName:"v-easyadmin",value:(_vm.easyadminId),expression:"easyadminId"}],tag:"component",class:_vm.contentType,attrs:{"content":_vm.launchContent}})
}
var staticRenderFns = []

export { render, staticRenderFns }